import { _ } from "../../../core/polyglot/polyglot.js";
import { eventCategory } from "@foretagsplatsen/yaem";
import {
	formatAsLongDate,
	formatAsLongDateAndTime,
} from "../../../core/helpers/date-formatting-util.js";
import { widget } from "@foretagsplatsen/widgetjs";
import selection from "../../../models/accounting/document/selection.js";

/**
 * I am the abstract widget used to render an entry.
 * See my subclasses for concrete implementation.
 * To be instantiated properly, I need:
 *  - model:    an `entry'
 *  - position:    an integer representing my position in the widgets
 *    (used for -shift- selection)
 * My role is to expose the polymorphic API
 */

/**
 * Todo: Add JSDoc comment
 */
function entryWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	const model = spec.model;
	const position = spec.position;
	let checkbox;
	let brush;
	const eventManager = eventCategory();

	my.trigger = eventManager.trigger;
	that.on = eventManager.on;
	that.register = eventManager.register;

	that.model = function () {
		return model;
	};

	that.position = function () {
		return position;
	};

	that.clickAction = function (event) {
		if (spec.action) {
			spec.action();
		} else {
			my.onClickAction();
		}
		event.stopPropagation();
	};

	that.doubleClickAction = function (event) {
		that.clickAction(event);
	};

	that.setSelected = function () {
		if (!brush) {
			return;
		}
		brush.addClass("active");
		if (checkbox) {
			checkbox.asJQuery().attr("checked", true);
		}
	};

	that.unsetSelected = function () {
		if (!brush) {
			return;
		}
		brush.removeClass("active");
		if (checkbox) {
			checkbox.asJQuery().attr("checked", false);
		}
	};

	that.setCut = function () {
		brush.addClass("cut");
	};

	that.click = function (action) {
		brush.click(action);
	};

	that.checkboxClick = function (action) {
		checkbox.click((event) => {
			action(event);
			event.stopPropagation();
		});
	};

	that.onMouseMove = function (callback) {
		brush.asJQuery().mousemove(callback);
	};

	that.renderListViewOn = function (html) {
		brush = html.tr({ klass: "entryWidget" }).render((row) => {
			row.td(
				(html) => {
					checkbox = html.input({
						type: "checkbox",
						"data-test": "select-entry",
					});
				},
				my.renderIconOn,
				(html) => {
					const anchor = html.a(that.model().name());
					anchor.click(that.clickAction);
				},
			);

			row.td().render((html) => {
				if (that.model().isFile()) {
					html.render(_("File"));
				} else {
					html.render(_("Folder"));
				}
			});

			const dateAndTime = that.model().creationTime();

			row.td(
				{
					title: formatAsLongDateAndTime(dateAndTime),
					"data-toggle": "tooltip",
					"data-placement": "top",
				},
				formatAsLongDate(dateAndTime),
			);
		});

		if (isSelected()) {
			that.setSelected();
		}

		brush.dblclick(that.doubleClickAction);
	};

	that.renderIconicViewOn = function (html) {
		brush = html
			.div({ klass: "entryWidget iconicWidget", "data-test": "file" })
			.render((html) => {
				html.div({ klass: ["big_icon", "doc-icon", my.icon()] });

				html.div({ klass: "name" }, (html) => {
					const anchor = html.a(that.model().name());
					anchor.click(that.clickAction);
				});
			});

		if (isSelected()) {
			that.setSelected();
		}
		if (that.model().isPreliminary()) {
			brush.addClass("preliminary");
		}

		brush.dblclick(that.doubleClickAction);
	};

	my.onClickAction = function () {
		// To override in subclasses
	};

	my.renderIconOn = function (html) {
		html.tag("i").addClass(my.listIcon());
	};

	my.listIcon = function () {
		return "fa fa-fire";
	};

	my.icon = function () {
		return "fa fa-fire";
	};

	my.brush = function () {
		return brush;
	};

	function isSelected() {
		return selection.includesEntry(that.model());
	}

	return that;
}

export default entryWidget;
